import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 1;
  border-radius: 9.843px;
  background: #fff;
  box-shadow: 0px 1.85px 9.24px 0px rgba(0, 0, 0, 0.1);
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 700px;
  max-width: 700px;
  margin-top: 16px;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space};
`;

export const SpaceX = styled.div`
  width: ${(props: any) => props.space};
`;

export const Card = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  border: 1.5px solid #f43636;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  padding: 16px 48px;
`;

export const CardTextStrong = styled.p`
  color: var(--Support-Colors-Error-Error, #f43636);
  text-align: center;
  font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  margin-right: 8px;
  display: inline;
  text-align: center;
`;

export const CardText = styled.p`
  color: var(--Support-Colors-Error-Error, #f43636);
  font-family: Inter;
  font-size: 30px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  display: inline;
  flex-direction: row;
  align-items: center;
  text-align: center;
`;

export const CardTextSmall = styled.p`
  color: var(--Support-Colors-Error-Error, #f43636);
  font-family: Inter;
  font-size: 26px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;

export const Position = styled.p`
  display: flex;
  font-family: Inter;
  height: 22px;
  min-width: 22px;
  background-color: #f43636;
  border-radius: 11px;
  position: absolute;
  top: 8px;
  left: 8px;
  align-items: center;
  justify-content: center;
  padding: 1.5px;
`;
export const PositionText = styled.p`
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
  line-height: 14px;
`;

export const TextStrong = styled.p`
  color: var(--Support-Colors-Error-Error, #f43636);
  text-align: center;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.2px;
`;
